module.exports = __webpack_public_path__ + "static/media/management.5ec67cbd.png";